import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-neutral-bg py-6 px-4 sm:px-6 lg:px-8 border-y border-neutral-beige" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <div className="bg-white rounded-2xl p-5 sm:p-6 border border-neutral-beige shadow-md flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-37">
          <div className="w-14 h-14 flex-shrink-0 bg-garden-bg rounded-full flex items-center justify-center text-3xl shadow-inner border border-garden-light/30" data-id="element-38">
            🔒
          </div>
          <div className="text-center sm:text-left" data-id="element-39">
            <h2 className="font-serif text-xl font-black text-[#1A1A1A] uppercase mb-1 tracking-wide" data-id="element-40">
              Garantía sin riesgo
            </h2>
            <p className="text-base text-gray-600 font-medium max-w-xl leading-relaxed" data-id="element-41">
              Tienes 7 días para probarlo. Si no sientes claridad para empezar,
              te devolvemos el 100%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}